import {Pipe, PipeTransform} from '@angular/core';
import {PricePipe} from '../price/price.pipe';
import {LegacyTicket, SurchargeType} from '../../generated/sales-terminal-client';
import {sumBy} from 'lodash-es';

@Pipe({
  name: 'ticketPrice'
})
export class TicketPricePipe implements PipeTransform {
  constructor(private pricePipe: PricePipe) {}

  transform(ticket: LegacyTicket, onlyHidden: boolean = false, noCurrency = false): string {
    return this.pricePipe.transform(this.calculatePrice(ticket, onlyHidden), noCurrency);
  }
  calculatePrice(ticket: LegacyTicket, onlyHidden: boolean = false): number {
    const feeTotal: number = sumBy((ticket.surcharges || []).filter(fee =>
      (!onlyHidden && fee.type !== SurchargeType.Service || (fee.type && fee.type === SurchargeType.Hidden))), 'price');
    return ticket.price + (feeTotal > 0 ? feeTotal : 0);
  }
}
